import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { ChangelogComment } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface UpdateCommentRequest {
  text: string;
}

export interface UpdateCommentResponse {
  success: boolean;
  comment: ChangelogComment;
}

interface UseUpdateCommentVariables {
  workspaceId: number;
  commentId: number;
  data: UpdateCommentRequest;
}

export const useUpdateComment = (
  options?: UseMutationOptions<UpdateCommentResponse, Error, UseUpdateCommentVariables>,
) => {
  const userToken = useAuth()?.userToken ?? "";

  return useMutation<UpdateCommentResponse, Error, UseUpdateCommentVariables>({
    mutationFn: async ({ workspaceId, commentId, data }) => {
      const response = await fetch(ENDPOINTS.changelog_comment(workspaceId, commentId), {
        method: "PATCH",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(data),
      });

      return handleResponse(response);
    },
    ...options,
  });
};
